import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiDatabase } from 'react-icons/fi';

const DataTables = () => {
  return (
    <section className="py-12 px-4 max-w-7xl mx-auto" id="specs">
      <div className="flex items-center gap-2 text-white font-mono text-xl mb-6">
        <SafeIcon icon={FiDatabase} className="text-electric" />
        SPEC_COMPARISON_MATRIX
      </div>

      <div className="overflow-x-auto dashboard-panel">
        <table className="w-full text-left font-mono text-sm">
          <thead className="bg-graphite-900 border-b border-graphite-700 text-graphite-600">
            <tr>
              <th className="p-4 font-normal">PARAMETER</th>
              <th className="p-4 font-normal text-white">KAIRO CORE 20K</th>
              <th className="p-4 font-normal text-white">AEROCHARGE MINI</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-graphite-700">
            <tr className="hover:bg-graphite-700/50 transition-colors">
              <td className="p-4 text-electric">CAPACITY</td>
              <td className="p-4">20,000 mAh (74Wh)</td>
              <td className="p-4">10,000 mAh (37Wh)</td>
            </tr>
            <tr className="hover:bg-graphite-700/50 transition-colors">
              <td className="p-4 text-electric">MAX OUTPUT</td>
              <td className="p-4">65W (PD 3.0)</td>
              <td className="p-4">20W (PD 3.0)</td>
            </tr>
            <tr className="hover:bg-graphite-700/50 transition-colors">
              <td className="p-4 text-electric">PORTS</td>
              <td className="p-4">2x USB-C, 1x USB-A</td>
              <td className="p-4">1x USB-C, 1x USB-A</td>
            </tr>
            <tr className="hover:bg-graphite-700/50 transition-colors">
              <td className="p-4 text-electric">WEIGHT</td>
              <td className="p-4">380g / 13.4oz</td>
              <td className="p-4">195g / 6.8oz</td>
            </tr>
            <tr className="hover:bg-graphite-700/50 transition-colors">
              <td className="p-4 text-electric">FLIGHT SAFE</td>
              <td className="p-4 text-green-400">YES (Under 100Wh limit)</td>
              <td className="p-4 text-green-400">YES</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default DataTables;